import {fetchReceiveOverview} from "../network/ReceiveNetworkAPI";

export const ReceiveOverViewReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_OVERVIEW":
            const {filter, cyclesDetail, capability, dispatcher} = action.data;
            fetchReceiveOverview(filter, cyclesDetail, capability, dispatcher)
            return state
        case "UNLOAD_VIEW":
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "RECEIVE_STOW_DATA":
            return {...state, ...action.data}
        case "RECEIVE_PLANNED_DATA":
            return {...state, ...action.data}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/receive/reducers/ReceiveOverViewReducer.js